import { useUserStore } from '@/stores/useUserStore'
import { getStoredUserId } from '../utils'

// MIRA-4332: Delegated Settings belong to the selected timekeeper for both
// reads and writes. A missing delegation target must not fall back to the admin.
export function useSettingsUserId(): string {
  return useUserStore(state => {
    if (state.isDelegationMode) return String(state.selectedUser?.id ?? '')
    return String(state.selfUser?.id ?? getStoredUserId())
  })
}

// The shared exclusion stores describe the signed-in user's capture rules.
// Inspect current state so a delegated response cannot overwrite those stores.
export function isSelfSettingsUser(userId: string): boolean {
  const { selfUser, isDelegationMode } = useUserStore.getState()
  return (
    !isDelegationMode &&
    Boolean(userId) &&
    userId === String(selfUser?.id ?? getStoredUserId())
  )
}
